export default "__VITE_ASSET__k$MyEWrLbG681yRwSJuz1w__"